import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusShape extends ToolStylus {
  static toolName = 'Shape';
  static shortcut = new Shortcut('S');

  static action({ controller }) {
    controller.actionSetStylus(controller.currentShapeStylus);
  }
}

export default ToolStylusShape;
